import { FechamentoMarcacao } from "../marcacao/fechamento-marcacao";

export class InformacaoFechamentoMarcacaoDTO {

    fechamentoMarcacao: FechamentoMarcacao | undefined;

    constructor() {
    }
}
